import {createSelector} from 'reselect';
import get from 'lodash/get';

import {getRankedBadges} from './listing';
import {getSiteName} from './system';

const badgeStyleConfig = {
    '32': {
        iconId: 'svg-yellow-star',
        bgColor: {
            vrbo: '#e4ebd5'
        }
    },
    '55': {
        bgColor: {
            default: '#8dc089'
        },
        textColor: 'rgba(0,0,0,0.85)'
    }
};

const createBadgeObj = (name, id, site) => {
    let styleObj = {};

    if (badgeStyleConfig[id]) {
        const bgColor = get(badgeStyleConfig[id], 'bgColor');
        const iconId = get(badgeStyleConfig[id], 'iconId');
        const textColor = get(badgeStyleConfig[id], 'textColor');

        styleObj.bgColor = bgColor[site] || bgColor.default || null;
        styleObj.iconId = iconId || null;
        styleObj.textColor = textColor || null;
    }

    return {
        ...styleObj,
        id,
        name
    };
};

const getBadgeArray = (badges, site) => {
    return badges.reduce((arr, badge) => {
        const {name, id} = badge;
        if (name && id) {
            arr.push(createBadgeObj(name, id, site));
            return arr;
        }
        return arr;
    }, []);
};

/* eslint-disable complexity */
const getListingOverviewBadges = createSelector(
    [getSiteName, getRankedBadges],
    (site, rankedBadges) => {
        const maxBadges = 6;
        return getBadgeArray(rankedBadges, site).splice(0, maxBadges);
    }
);
/* eslint-enable complexity */

export default getListingOverviewBadges;
export {getListingOverviewBadges};
